import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import RequestTypeForm from "./RequestTypeForm";

export interface State {}

export interface CreateRequestTypeFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
}

class CreateRequestTypeForm extends React.Component<
  CreateRequestTypeFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let newData = null;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newData = values;
        }
      });
      return newData;
    });
  }

  render() {
    const { translate } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <RequestTypeForm
        translate={translate}
        getFieldDecorator={getFieldDecorator}
      />
    );
  }
}

export default CreateRequestTypeForm;
